<div class="spinner-overlay">
  <img
     src="assets/images/revolver-cylinder.svg"
    class="revolver-spinner"
    alt="Loading..."
  />
  <p style="color: white; font-weight: bold">
    {{ sharedService.loading_message$ | async }}<span class="loading-dots"></span>
  </p>
</div>